/**
 * Formatadores e Conversores Puros Compartilhados
 */

export const formatDateBR = (dateString) => {
  if (!dateString) return "";

  if (typeof dateString === "string") {
    const trimmed = dateString.trim();
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) {
      return trimmed;
    }
    const matchIso = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (matchIso) {
      const [, ano, mes, dia] = matchIso;
      const numAno = Number(ano);
      const numMes = Number(mes);
      const numDia = Number(dia);
      if (numMes < 1 || numMes > 12 || numDia < 1 || numDia > 31) {
        return trimmed;
      }
      const testDate = new Date(numAno, numMes - 1, numDia);
      if (
        testDate.getFullYear() !== numAno ||
        testDate.getMonth() !== numMes - 1 ||
        testDate.getDate() !== numDia
      ) {
        return trimmed;
      }
      return `${dia}/${mes}/${ano}`;
    }
  }

  const d = new Date(dateString);
  if (isNaN(d.getTime())) return String(dateString || "");
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

export const formatarCnpjCpf = (valor) => {
  if (!valor) return "";

  const nums = valor.replace(/\D/g, "").slice(0, 14);
  if (nums.length === 0) return "";
  if (nums.length <= 11) {
    return nums
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  } else {
    return nums
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  }
};

export const isTelefonePlaceholder = (valor) => {
  if (!valor) return false;
  const nums = String(valor).replace(/\D/g, "");
  if (nums.length < 8) return false;
  return /^(\d)\1+$/.test(nums);
};

export const sanitizeTelefone = (valor) => {
  if (!valor) return "";
  if (isTelefonePlaceholder(valor)) return "";
  return String(valor);
};

export const formatarTelefone = (tel) => {
  if (!tel) return "";
  const nums = String(tel).replace(/\D/g, "");
  if (nums.length === 11) {
    return nums.replace(/(\d{2})(\d{5})(\d{4})/, "($1)$2-$3");
  } else if (nums.length === 10) {
    return nums.replace(/(\d{2})(\d{4})(\d{4})/, "($1)$2-$3");
  }
  return String(tel);
};

export const normalizeCPF = (cpf) => (cpf ? String(cpf).replace(/\D/g, "") : "");

export const formatarDataBR = formatDateBR;
export const formatarCnpj = (valor) => {
  if (!valor) return "";
  const str = String(valor);
  const digits = str.replace(/\D/g, "");
  if (digits.length === 14) {
    return digits.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5",
    );
  }
  if (digits.length === 11) {
    return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  }
  return str;
};

export const formatHorarioTeoricoLabel = (h) => {
  const inicio = h?.horario_inicio;
  const fim = h?.horario_fim;
  if (!inicio || !fim) return "";
  return `${inicio} às ${fim}`;
};

export const parseSalario = (val) => {
  if (val === null || val === undefined) return 0;
  if (typeof val === "number") return val;
  const cleaned = String(val)
    .replace("R$", "")
    .replace(/\s/g, "")
    .replace(/\./g, "")
    .replace(",", ".");
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
};

export const calcularIdade = (dataNascimento, hoje = new Date()) => {
  if (!dataNascimento) return null;
  const nasc = new Date(dataNascimento);
  if (isNaN(nasc.getTime())) return null;

  let idade = hoje.getFullYear() - nasc.getFullYear();
  const m = hoje.getMonth() - nasc.getMonth();
  if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) {
    idade -= 1;
  }
  return idade;
};

export const isMenorDeIdade = (idade) => {
  if (idade === null || idade === undefined) return false;
  return idade < 18;
};
